<!-- Spinner while catalog is being loaded -->
<div *ngIf="loading && !loadError" class="pd-loader">
    <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
</div>

<!-- Error loading content -->
<div *ngIf="!loading && loadError" class="pd-permission-error">
    <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
    There was an error loading feedback. Click below try again.
    <button hc-button size="lg" (click)="loadFeedback()">Reload Feedback</button>
</div>

<div class="admin-product-catalog-table-container" [hidden]="loadError || loading">
    <h2>
        <span>
            <hc-icon fontSet="fa" fontIcon="fa-comments" class="feedback-icon"></hc-icon>
            Feedback Submissions
        </span>
    </h2>
    <div class="admin-product-catalog-control-bar">
        <div class="admin-product-catalog-filters">
            <div class="filter-dropdown" title="Filter by source">
                <label>Source</label>
                <button hc-button buttonStyle="link-inline" id="source" [hcPop]="filtermenu"
                    (click)="storeFilterData('source')" [context]="sourceFilters">
                    <span class="value hc-text-ellipsis filter-dropdown-length">{{ sourceText }}</span>
                    <hc-icon fontSet="fa" fontIcon="fa-chevron-down" hcIconSm></hc-icon>
                </button>
            </div>
            <div class="filter-dropdown" title="Filter by response">
                <label for="productStatus">Helpful</label>
                <button hc-button buttonStyle="link-inline" id="helpful" [hcPop]="filtermenu"
                    (click)="storeFilterData('helpful')" [context]="helpfulFilters">
                    <span class="value hc-text-ellipsis filter-dropdown-length">{{ helpfulText }}</span>
                    <hc-icon fontSet="fa" fontIcon="fa-chevron-down" hcIconSm></hc-icon>
                </button>
            </div>
            <hc-pop #filtermenu scrollStrategy="close" (opened)="filterSelections = $event">
                <filter-popover [filterData]="filterData" [setVals]="filterSelections" (close)="filtermenu.close()"
                    (filterChecked)="storeFilterArray($event)"></filter-popover>
            </hc-pop>
        </div>
        <div class="control-bar-right">
            <hc-search-bar #searchbar placeholder="Search submissions" (triggerSearch)="applySearchFilter($event)"
                class="admin-product-catalog-search"></hc-search-bar>
        </div>
    </div>
    <table hc-table [borders]="false" [dataSource]="dataSource" hcSort>
        <!-- Date Column -->
        <ng-container hcColumnDef="date">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="date">Date</th>
            <td hc-cell *hcCellDef="let element">{{ element.date | date: 'shortDate' }}</td>
        </ng-container>

        <!-- Source Column -->
        <ng-container hcColumnDef="source">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="source">Source</th>
            <td hc-cell *hcCellDef="let element">{{ element.source }}</td>
        </ng-container>

        <!-- Helpful Column -->
        <ng-container hcColumnDef="helpful">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="helpful">Helpful</th>
            <td hc-cell *hcCellDef="let element">{{ element.helpful }}</td>
        </ng-container>

        <!-- Responded Column -->
        <ng-container hcColumnDef="responded">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="responded">Responded</th>
            <td hc-cell *hcCellDef="let element">
                <hc-checkbox (change)="checkEvent($event, element)" [checked]="element.responded === true" [disabled]="respondedUpdating"></hc-checkbox>
            </td>
        </ng-container>

        <!-- URL Column -->
        <ng-container hcColumnDef="url">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="url">Url</th>
            <td hc-cell *hcCellDef="let element">{{ element.url }}</td>
        </ng-container>

        <!-- Suggestions Column -->
        <ng-container hcColumnDef="suggestions">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="suggestions">Suggestions</th>
            <td hc-cell *hcCellDef="let element">{{ element.suggestions }}</td>
        </ng-container>

        <!-- Email Column -->
        <ng-container hcColumnDef="email">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="email">Email</th>
            <td hc-cell *hcCellDef="let element">{{ element.email }}</td>
        </ng-container>

        <tr hc-header-row *hcHeaderRowDef="adminFeedbackDisplayedColumns"></tr>
        <tr hc-row *hcRowDef="let row; columns: adminFeedbackDisplayedColumns"></tr>
    </table>

    <div class="hc-empty-table-block" *ngIf="dataSource.filteredData.length === 0">
        <span class="hc-empty-table-block-ico hc-empty-ico"></span>
        <span class="hc-empty-table-block-msg">No submissions meet your search criteria.</span>
    </div>

    <hc-pagination [length]="adminFeedbackListLength" [pageSize]="adminFeedbackPageSize" [hidden]="loadError || loading"></hc-pagination>
</div>